<template>
  <div class="passengersSelect">
    <div
      class="passengersSelect__container"
      v-for="(pax, index) in passengersEnabled"
      :key="'pax' + index"
    >
      <div class="inputSelect">
        <label v-if="showInputLabel"
               class="inputSelect__label"
               :for="pax.ptc"
        >
          {{ $t(`${pax.ptc}_quantity`) }}
        </label>
        <div class="inputSelect__group">
          <select class="inputSelect__input"
                  :name="pax.ptc"
                  v-model="passengerStatus[pax.ptc]"
                  @change="e => changeSelect(pax, parseInt(e.currentTarget.value))"
          >
            <option v-for="id in range(pax)"
                    :key="`adult-${id}`"
                    :value="id">
              {{ id }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// https://kiu.atlassian.net/wiki/spaces/KE/pages/4054447/KE+An+lisis+SPA+Search+Flight
import passengers from './Passengers'
import { range } from 'lodash'

export default {
  name: 'Passengers',
  mixins: [
    passengers
  ],
  data () {
    return {
      counts: undefined
    }
  },
  methods: {
    getMaxQuantity: function (type) {
      return this.passengersEnabled.find(x => x.code === type).max_quantity
    },
    changeSelect: function (pax, value) {
      if (pax.ptc === 'ADT') {
        this.counts.CHD = (this.getMaxQuantity('CHD') + this.totalAdults) <= 9 ? this.getMaxQuantity('CHD') : 9 - this.totalAdults
        if (this.counts.CHD <= 0) {
          this.passengerStatus.CHD = 0
        }
        this.counts.INF = this.getMaxQuantity('INF') < value ? this.getMaxQuantity('INF') : value
        if (this.passengerStatus.INF > this.passengerStatus.ADT) {
          this.passengerStatus.INF = value
        }
      } else if (pax.ptc === 'CHD') {
        this.counts.ADT = (this.getMaxQuantity('ADT') + this.totalChild) <= 9 ? this.getMaxQuantity('ADT') : 9 - this.totalChild
        if (this.counts.ADT <= 0) {
          this.passengerStatus.ADT = 0
        }
      }
      this.save()
    },
    range: function (pax) {
      if (!this.counts) {
        this.counts = {}
        this.passengersEnabled.forEach(x => {
          this.counts[x.ptc] = x.max_quantity
        })
        this.counts.INF = 1
        if (this.counts.CHD + this.passengerStatus.ADT > 9) {
          this.counts.CHD -= this.passengerStatus.ADT
        }
      }
      let min = pax.min_quantity
      return range(min, this.counts[pax.ptc] + 1)
    }
  }
}
</script>

<style lang="sass">
.passengersSelect
  width: 100%
  display: flex
  &__container
    width: 100%
    &:first-child
      .inputSelect__input
        min-width: 4rem
        border-top-right-radius: 0
        border-bottom-right-radius: 0
    &:nth-child(2)
      .inputSelect__input
        min-width: 4rem
        border-radius: 0
        border-right: 0
        border-left: 0
    &:last-child
      .inputSelect__input
        border-top-left-radius: 0
        border-bottom-left-radius: 0
  .inputSelect
    &__input
      min-width: 4rem
</style>
